import * as miljogebyrEttersendelserActions from "../actions/miljogebyrEttersendelserActions";

const INITIAL_STATE = [];

export default function miljogebyrEttersendelserReducer(
  state = INITIAL_STATE,
  action,
) {
  switch (action.type) {
    case miljogebyrEttersendelserActions.GET_MILJOGEBYR_ETTERSENDELSER_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}
